// engineCommands.ts
import { Bid, BoardReviewData, Card, ClickEventData } from '../../app/types';
import { createAction } from '@reduxjs/toolkit';
import type { OutputButton } from '../../slices/outputSlice';

export const engineButtonClicked = createAction<OutputButton>('engine/buttonClicked');

export const engineMakeBid = createAction<Bid>('engine/makeBid');

// Explain some bid in the auction (by index)
export const engineExplainBid = createAction<number>('engine/explainBid');

// Explain *my* bid (full Bid object)
export const engineExplainMyBid = createAction<Bid>('engine/explainMyBid');

// Cancel whatever explanation is in-flight / being shown
export const engineCancelBidExplanation = createAction('engine/cancelBidExplanation');

export const engineMakePlay = createAction<Card>('engine/makePlay');

export const engineApproveClaim = createAction<'approve' | 'reject'>('engine/approveClaim');

export const engineApproveUndo = createAction<'approve' | 'reject'>('engine/approveUndo');

export const engineHTMLLink = createAction<ClickEventData>('engine/htmlLink');

export const engineLoadBoardReviewData = createAction<BoardReviewData>('engine/loadBoardForReview');

export const engineReloadBoardReviewData = createAction<BoardReviewData>('engine/loadBoardForReview');

// add more as needed
